// "Лимит обновится через X" suffix for the subscribed-user quota notice.
// Ported from messaging.js _formatResetIn (parent bc12bfdf). Accepts an ISO
// timestamp (reset_at = last_usage_date + 7d) and returns a Russian phrase,
// falling back gracefully when it's missing or already in the past.

function pluralHours(h: number): string {
  const mod10 = h % 10
  const mod100 = h % 100
  if (mod10 === 1 && mod100 !== 11) return 'час'
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 'часа'
  return 'часов'
}

function pluralDays(d: number): string {
  const mod10 = d % 10
  const mod100 = d % 100
  if (mod10 === 1 && mod100 !== 11) return 'день'
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 'дня'
  return 'дней'
}

export function formatResetIn(resetAt: string | null | undefined): string {
  if (!resetAt) return 'Лимит обновится автоматически в ближайшее время.'
  const ms = new Date(resetAt).getTime() - Date.now()
  if (!Number.isFinite(ms) || ms <= 0) return 'Лимит скоро обновится — попробуйте ещё раз.'

  // Sub-day intervals show hours; >=24h shows days.
  const hours = ms / 3_600_000
  if (hours < 24) {
    const h = Math.ceil(hours)
    return `Лимит обновится через ${h} ${pluralHours(h)}.`
  }
  const days = Math.ceil(ms / 86_400_000)
  return `Лимит обновится через ${days} ${pluralDays(days)}.`
}
